import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card, Col, Form, Modal, Row, Table } from "@themesberg/react-bootstrap";
import { useEffect, useState } from "react";
import { useContext } from "react";
import { PropertyContext } from "../contexts/PropertyContext";
import NotFound from "./NotFound";

const SearchIndexEditModal = ({
	propertySearchIndex,
	propertyDataLite,
	getAllPropertyLiteFromContext,
	editData,
	setEditData,
	getAllSearchIndexFromContext,
	updateSearchIndexFromContext,
	showModal,
	setShowModal,
}) => {
	const [propertyId, setPropertyId] = useState(0);
	const [searchScore, setSearchScore] = useState(0);

	useEffect(() => {
		if (editData) {
			setPropertyId(editData?.id);
			setSearchScore(editData?.search_score);
		}
	}, [editData]);

	useEffect(() => {
		getAllPropertyLiteFromContext();
	}, []);

	const handleOnSubmit = () => {
		updateSearchIndexFromContext(propertyId, { search_score: searchScore }, () => {
			getAllSearchIndexFromContext();
			setShowModal(!showModal);
			setEditData(null);
		});
	};

	return (
		<Modal centered size="lg" className="modal-tertiary" show={showModal} onHide={() => {}}>
			<Modal.Header>
				<Button
					variant="close"
					className="btn-close-dark text-dark"
					aria-label="Close"
					onClick={() => {
						setShowModal(false);
						setEditData(null);
					}}
				/>
			</Modal.Header>
			<Modal.Body className=" py-3">
				<div className="px-5">
					<center>
						<h5 className="mb-4">Edit Search score</h5>
					</center>
					<Row>
						<Col></Col>
						<Col md={6} className="mb-3">
							<Form.Group id="propertyId">
								<Form.Label>Property Id</Form.Label>
								<Form.Select
									value={propertyId}
									onChange={(e) => setPropertyId(e?.target?.value)}
								>
									<option value="0">Select Property</option>
									{propertyDataLite?.length > 0 &&
										propertyDataLite
											?.filter(
												(property) =>
													!propertySearchIndex
														?.map((searchIdx) => searchIdx?.id)
														?.includes(property?.id)
											)
											?.map((property) => (
												<option value={property?.id}>
													{property?.name}
												</option>
											))}
								</Form.Select>
							</Form.Group>
						</Col>
						<Col></Col>
					</Row>
					<Row>
						<Col></Col>
						<Col md={6} className="mb-3">
							<Form.Group id="propertySearchIndex">
								<Form.Label>Search score</Form.Label>
								<Form.Control
									required
									type="number"
									min={0}
									name="searchscore"
									value={searchScore}
									onChange={(e) => setSearchScore(e?.target?.value)}
									placeholder="Enter Search score"
								/>
							</Form.Group>
						</Col>
						<Col></Col>
					</Row>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<Row>
					<Col lg={12}>
						<div className="mx-4 text-end">
							<Button variant="dark" onClick={() => handleOnSubmit()}>
								Update
							</Button>
						</div>
					</Col>
				</Row>
			</Modal.Footer>
		</Modal>
	);
};

const PropertySearchIndex = () => {
	const {
		propertyDataLite,
		getAllPropertyLiteFromContext,
		propertySearchIndex,
		getAllSearchIndexFromContext,
		updateSearchIndexFromContext,
	} = useContext(PropertyContext);

	const [showModal, setShowModal] = useState(false);
	const [editData, setEditData] = useState(null);

	useEffect(() => {
		getAllSearchIndexFromContext();
	}, []);

	return (
		<>
			{showModal && (
				<SearchIndexEditModal
					{...{
						propertySearchIndex,
						propertyDataLite,
						getAllPropertyLiteFromContext,
						editData,
						setEditData,
						showModal,
						setShowModal,
						getAllSearchIndexFromContext,
						updateSearchIndexFromContext,
					}}
				/>
			)}
			<div className="d-flex justify-content-between align-items-center w-100">
				<Button
					variant="secondary"
					className="mt-4 text-dark"
					onClick={() => setShowModal(!showModal)}
				>
					<FontAwesomeIcon icon={faPlus} className="me-2" />
					Add Search Score
				</Button>
			</div>
			<div className="py-4">
				<Card>
					{propertySearchIndex && propertySearchIndex.length > 0 && (
						<Table>
							<thead className="thead-light">
								<tr>
									<th className="border-0">#ID</th>
									<th className="border-0">Name</th>
									<th className="border-0">District</th>
									<th className="border-0">Type</th>
									<th className="border-0 text-center">Search Score</th>
									<th className="border-0 text-center">Action</th>
								</tr>
							</thead>
							<tbody>
								{propertySearchIndex?.map((property) => (
									<tr>
										<td className="border-0 fw-bold">{property.id}</td>
										<td className="border-0">
											<span className="h6">{property.name}</span>
										</td>
										<td className="border-0 fw-bold">
											{property.district.name}
										</td>
										<td className="border-0 fw-bold">
											{property.property_type.name}
										</td>
										<td className="border-0 text-center">
											{property.search_score ?? 0}
										</td>
										<td className="border-0 text-center">
											<Button
												variant="light"
												className="m-1 p-2 fw-bold"
												style={{ fontSize: "13px" }}
												onClick={(e) => {
													setEditData(property);
													setShowModal(!showModal);
												}}
											>
												<b>Edit</b>
											</Button>
										</td>
									</tr>
								))}
							</tbody>
						</Table>
					)}
					{propertySearchIndex && propertySearchIndex.length <= 0 && (
						<center className="my-4">
							<NotFound isData={true} />
						</center>
					)}
				</Card>
			</div>
		</>
	);
};

export default PropertySearchIndex;
